import {h, Fragment} from "preact"
import { useEffect, useMemo, useRef, useState } from "preact/hooks"
import { addToCart, sortData } from "../helpers"
import { sizesOrder } from "../config"

export default function AddToCart({ product }) {
    const [ active, setActive ] = useState(false);
    const [ atcText, setAtcText ] = useState('Add to bag');
    const productOos = useMemo(() => product.availability === "OutOfStock", [ product ])

    const sortedSkus = useMemo(() => 
        sortData(
            product.skus, 
            sizesOrder, 
            (sku) => (sku.attributes ?? sku.customFields)?.find(f => f.key.toLowerCase() === "size")?.value
        )
    , [ product ])

    const containerRef = useRef(null);
    const activeRef = useRef(active);

    useEffect(() => {
        activeRef.current = active;
    }, [active])

    useEffect(() => {
        const handleLeave = (e) => {
            if(!activeRef.current) return;
            setActive(false)
        }

        const imageContainer = containerRef?.current?.closest('.ns-media-wrap');
        if(!imageContainer) return;

        if('onpointerleave' in window) {
            imageContainer.addEventListener('pointerleave', handleLeave);
        } else {
            imageContainer.addEventListener('mouseleave', handleLeave);
            imageContainer.addEventListener('touchend', handleLeave);
        }
        
        return () => {
            if('onpointerleave' in window) {
                imageContainer.removeEventListener('pointerleave', handleLeave);
            } else {
                imageContainer.removeEventListener('mouseleave', handleLeave);
                imageContainer.removeEventListener('touchend', handleLeave);
            }
        }
    }, [])

    useEffect(() => {
        containerRef?.current?.closest('.ns-product')?.style?.setProperty('--ns-container-height', containerRef?.current?.scrollHeight + 'px')
    }, [ product ])

    const handleAddToCart = (skuId) => {
        addToCart(skuId);
        setAtcText('Added!');
        setTimeout(() => {
            setAtcText('Add to bag')
        }, 2000)
    }

    return (
        <div class={`ns-atc-wrap ns-absolute ns-flex ns-flex-col ${active ? "ns-active" : ""}`}>
            <div 
                class="ns-atc-sizes ns-flex ns-items-center ns-justify-center ns-flex-wrap"
                id={`size-options-${product.productId}`}
                aria-label="Select a size"
                role="group"
                ref={containerRef}
            >
                {product.skus?.length > 0 && (
                    <>
                    {sortedSkus.map(sku => {
                        const skuName = (sku.attributes ?? sku.customFields)?.find(f => f.key.toLowerCase() === "size")?.value;
                        return (<button
                            key={sku.id}
                            class="ns-size-btn"
                            type="button"
                            disabled={sku.availability === "OutOfStock"}
                            aria-disabled={sku.availability === "OutOfStock"}
                            onClick={() => { 
                                if(sku.availability === "InStock") { 
                                    handleAddToCart(sku.id) 
                                } 
                            }}
                        >
                            {skuName === 'Default Title' ? 'One Size' : skuName}
                        </button>
                        )
                    })}
                    </>
                )}
            </div>
            <button
                class={`ns-product-atc ns-block ns-w-full ${(productOos || !product.skus?.length) ? "ns-disabled" : ""}`} 
                type="button"
                aria-controls={`size-options-${product.productId}`}
                onClick={() => {
                    if(product.skus?.length > 0) {
                        setActive(curActive => !curActive)
                    }
                }}
            >
                {productOos ? "Out of Stock" : atcText}
            </button>
        </div>
    )
}
